<template>
    <div class="home_container">
      <img class="home_bg" src="../assets/img/sbb_bg.png" alt="" />
      <div class="home_page">
        <img class="sbb_tip" src="../assets/img/sbb_tip.png" alt="" />
        <img class="sbb_logo" src="../assets/img/app_icon.png" alt="" />
        <h4 class="name">数据保险箱</h4>
        <p class="tip">您的数据资产化管控专家</p>
        <div class="download_wrap" v-if="deviceType == 'Android'">
          <a href="https://www.iclabs.cn/datasafe_appV1.4.apk"></a>
          <img src="../assets/img/android_icon.png" alt="" />
          <span>免费下载安卓版</span>
        </div>
        <div class="download_wrap" v-if="deviceType == 'iOS'">
          <a href="https://apps.apple.com/cn/app/数据保险箱/id6744095220"></a>
          <img src="../assets/img/mac_logo.png" alt="" />
          <span>免费下载iOS版</span>
          <!-- <span>IOS版本等待上架</span> -->
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        deviceType: "",
      };
    },
    beforeMount() {
      this.detectDeviceType();
    },
    methods: {
      detectDeviceType() {
        let userAgent = navigator.userAgent;
        let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent
        )
      //   console.log(userAgent)
        if (isMobile) {
          // 进一步判断是安卓还是苹果
          if (/Android/i.test(userAgent)) {
            this.deviceType = "Android";
          } else if (/iPhone|iPad|iPod/.test(userAgent)) {
            this.deviceType = "iOS";
          }
          // this.$router.replace('/downloadSbb');
        } else {
          // this.deviceType = 'Desktop';
          this.$router.replace("/download");
        }
        // console.log('Device Type:', this.deviceType);
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .home_container {
    width: 100%;
    min-height: 100%;
    //   position: relative;
  }
  .home_bg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  .home_page {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
    box-sizing: border-box;
  
    .sbb_tip {
      width: 100%;
      height: 242px;
      margin-top: 62px;
      z-index: 1;
    }
    .sbb_logo {
      width: 70px;
      height: 70px;
      margin-top: 36px;
      position: relative;
    }
    .name {
      height: 38px;
      font-weight: 400;
      font-size: 20px;
      color: #333333;
      line-height: 38px;
      margin-top: 12px;
    }
    .tip {
      height: 24px;
      font-weight: 400;
      font-size: 17px;
      color: #666666;
      line-height: 24px;
      margin-top: 4px;
    }
    .download_wrap {
      // width: 420px;
      height: 49px;
      background: #2f51ff;
      border-radius: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 25px;
      margin-top: 20px;
      position: relative;
      overflow: hidden;
  
      img {
        width: 28px;
        height: 28px;
        margin-right: 6px;
        position: relative;
      }
      span {
        height: 25px;
        font-weight: 400;
        font-size: 18px;
        color: #ffffff;
        line-height: 25px;
        position: relative;
      }
      a {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        &:active {
          background: transparent;
        }
      }
    }
  }
  </style>
  